module.exports = __webpack_public_path__ + "img/service_1.462228dc.png";